var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.25C10 18.9375 10.5625 19.5 11.25 19.5C11.9375 19.5 12.5 18.9375 12.5 18.25C12.5 17.5625 11.9375 17 11.25 17C10.5625 17 10 17.5625 10 18.25ZM10 0.75V5.75H12.5V3.35C16.7375 3.9625 20 7.5875 20 12C20 16.8375 16.0875 20.75 11.25 20.75C6.4125 20.75 2.5 16.8375 2.5 12C2.5 9.9 3.2375 7.975 4.475 6.475L11.25 13.25L13.0125 11.4875L4.5125 2.9875V3.0125C1.775 5.0625 0 8.3125 0 12C0 18.2125 5.025 23.25 11.25 23.25C17.4625 23.25 22.5 18.2125 22.5 12C22.5 5.7875 17.4625 0.75 11.25 0.75H10ZM18.75 12C18.75 11.3125 18.1875 10.75 17.5 10.75C16.8125 10.75 16.25 11.3125 16.25 12C16.25 12.6875 16.8125 13.25 17.5 13.25C18.1875 13.25 18.75 12.6875 18.75 12ZM3.75 12C3.75 12.6875 4.3125 13.25 5 13.25C5.6875 13.25 6.25 12.6875 6.25 12C6.25 11.3125 5.6875 10.75 5 10.75C4.3125 10.75 3.75 11.3125 3.75 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.9e22285613fc91587888c389ed8dac3d.svg";
export { ForwardRef as ReactComponent };